import React from 'react'
import PropTypes from 'prop-types'
import Img from './Img'
import icons from '../enums/icons'

class Icon extends React.Component {
	render() {
		const { name, ...props } = this.props
		return (
			<Img content={icons[name]} {...props} />
		)
	}
}

Icon.propTypes = {
	name: PropTypes.string.isRequired
}

export default Icon



// WEBPACK FOOTER //
// ./src/components/Icon.jsx